import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Container, Segment, Sticky, Grid, Input, Transition, Divider, Loader } from 'semantic-ui-react';
import { Button, Form, Icon, Message, Progress, Image } from 'semantic-ui-react';
import { Link, Redirect } from 'react-router-dom';

const Privacy = () => {

  const PageHeader = () => {
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              as={Link}
              to="/"
              inverted
              content="Homecare"
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };

  return (
        <Grid container>
        <Segment style={{ padding: '3em 0em' }} vertical>
    <Grid.Row>
      <Grid.Column width={16} >
        <Header as='h3' style={{ fontSize: '1.63em' }} >Privacy Policy
        </Header>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.33em', marginTop: 40 }} >
        Privacy Statement
          </Header>
        <p style={{ fontSize: '1.00em' }}>
        Homecare (“Homecare”, “us”, “we” or “our”) has developed this privacy statement for you, the visitor/user, to demonstrate our commitment to privacy on the Internet. This Privacy Statement describes the type of information we gather about you when you use and access https://thefinalhomecare.web.app/ how we use that information and how we disclose it to third parties. https://thefinalhomecare.web.app/ is owned and operated by Homecare as a task management tool for families and caregivers. Your privacy is important to us. This Privacy Statement applies to the online collection of Personal Information via our Services. 
{/* /content/dam/city/depts/fss/supp_info/SeniorServices/HDM/HDMprojectlistbypsa080119.pdf */}
        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.33em', marginTop: 40 }} >
        Collection of Personal Information from Site and Visitors

        </Header>
        <p style={{ fontSize: '1.00em' }}>
        We collect information directly from information you enter, and our web server logs. We use this information primarily to provide you an experience with our Web Services that is personalized for you and that delivers the information, services, resources and products that are most relevant and useful to you. We do not share information provided by you that is personally identifiable with others unless we say so in this Privacy Statement, where we are otherwise required by law or contract to do so or where you give us permission.



        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.33em', marginTop: 40 }} >
        Use of Personal Data Collected

</Header>
        <p style={{ fontSize: '1.00em' }}>
        Personal data collected by Homecare may be used to communicate with you, for feedback purposes, for marketing and promotional purposes, for a statistical analysis of users' behavior, for product development, for content improvement. The information collected by the Web Services also may be used for responding to your inquiries and otherwise corresponding with you, for other purposes permitted by your customer agreement (if any) for products and services, to maintain the security and integrity of the Web Services for the purpose of conducting market research or surveys on our behalf, and for the administration, review and/or the improvement of the content of the Web Services.  


        </p>
      </Grid.Column>
    </Grid.Row>

    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.33em', marginTop: 40 }} >
        Disclosure of Personal Data to Third Parties
</Header>
        <p style={{ fontSize: '1.00em'}}>
        Homecare does not sell, rent, or intentionally make publicly available any individually identifying information. We may disclose your Personal Information to individuals involved in the seniors’ care that you authorize, such as family members, including people you have engaged to provide you services such as doctors or other care providers. Other than as described in this Privacy Statement, Homecare will not disclose any identifiable Personal Information about your usage of our Web Services to unaffiliated third parties, except as necessary to service the account, to enforce the terms of use, to meet our obligations to content and technology providers, or as required by law.

        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.33em', marginTop: 40 }} >
        Changing or Deleting Personal Data
</Header>
        <p style={{ fontSize: '1.00em'}}>
        Homecare strives to maintain the accuracy of the Personal Information collected through our website. Where we maintain specific Personal Information about you, we will provide you with access to personally identifiable information you provide through the Web Services for as long as we maintain that information in a readily accessible and retrievable format. We will also work with you to correct any information you submitted to us upon your request.  You may cancel your registration or update your preferences at any time. The access and correction provisions of this Privacy Statement only apply to personally identifiable information collected from you through the Web Services.


        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.33em', marginTop: 40 }} >
        Our Right to Change Privacy Statement

</Header>
        <p style={{ fontSize: '1.00em'}}>
        We may update this Privacy Policy occasionally to reflect changes in our services and policies. When we post changes to this Privacy Policy, we also will add a “last updated” date.  We encourage you to review this Privacy Policy periodically to be informed of how we are protecting your information.


        </p>
        <br />
        <p style={{ fontSize: '1.00em'}}>
        Effective Date: May 20, 2020



        </p>
        <br />
        <p style={{ fontSize: '1.00em', marginTop: -30}}>
        How to Contact Homecare




        </p>
        <br />
        <p style={{ fontSize: '1.00em', marginTop: -30}}>
        Homecare can be contacted: 




        </p>
        <br />
        <p style={{ fontSize: '1.00em', marginTop: -30}}>
        By email to  homecarenuvention@gmail.com  By call to (312)-934-9963




        </p>

      </Grid.Column>
    </Grid.Row>
  </Segment>
  </Grid>
  );
};

export default Privacy;